<!-- Zweck: Stellt die HTML-Struktur für app dialogs domain suggestions component im Frontend bereit. -->
<div class="suggestionsbox" [class.mobile]="msvc.isMobile()|async">
  <h1 mat-dialog-title>
    Wir haben einen speziellen Shop für Ihre Kundenart gefunden!
  </h1>
  <div mat-dialog-content style="padding: 10px; text-align: center">
    Wechseln Sie in den korrekten Shop!<br><br>
    <div>
      @for (sugg of suggestions; track sugg) {
        @for (d of sugg.domains; track d) {
          <a href="https://{{d.url}}" target="_self">
            <button mat-flat-button matTooltip="Diesen Shop wählen" style="height: 110px">
              <strong>{{d.label}}</strong>
              <hr style="border-color: white; margin-bottom: 0;">
              <small>{{d.url}}</small>
            </button>
          </a>
        }
      }
    </div>
  </div>
</div>
